import type { AnchorPoint } from 'metalworks-domain'
import { BehaviorSubject, type Observable } from 'rxjs'

interface AnchorPointsServiceState {
  visible: boolean
  measurementToolSourceId: AnchorPoint['id'] | null
  measurementToolDestinationId: AnchorPoint['id'] | null
}

class AnchorPointsService {
  private readonly _state$ = new BehaviorSubject<AnchorPointsServiceState>({
    visible: false,
    measurementToolSourceId: null,
    measurementToolDestinationId: null,
  })

  public readonly state$: Observable<AnchorPointsServiceState> = this._state$.asObservable()

  setVisible(visible: boolean) {
    this._state$.next({ ...this._state$.value, visible })
  }

  setMeasurementToolSourceId(sourceId: AnchorPoint['id'] | null) {
    this._state$.next({
      ...this._state$.value,
      measurementToolSourceId: sourceId,
      measurementToolDestinationId: null,
    })
  }

  setMeasurementToolDestinationId(destinationId: AnchorPoint['id'] | null) {
    this._state$.next({
      ...this._state$.value,
      measurementToolDestinationId: destinationId,
    })
  }
}

export const anchorPointsService = new AnchorPointsService()
